import moment from 'moment';

export const onUploadEvent = (e) => {
  if (Array.isArray(e)) {
    return e;
  }
  return e && e.fileList;
};

export const getFileURL = (upload) => {
  if (!upload) return undefined;
  if (upload.length > 0) return upload[upload.length - 1].response;
  return undefined;
};

export const getUrlFromEvent = (e) => {
  const upload = onUploadEvent(e);
  return getFileURL(upload);
};

export const getIsUploading = (e) => {
  return e.event && e.event.percent !== '100.00';
};

export const titleOptions = [
  { value: 'mr', label: 'Mr' },
  { value: 'mrs', label: 'Mrs' },
  { value: 'miss', label: 'Miss' },
  { value: 'ms', label: 'Ms' },
  { value: 'mx', label: 'Mx' },
];

export const genderOptions = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'other', label: 'Other' },
  { value: 'not-say', label: 'Prefer not' },
];

export const DEFAULT_BIRTH_YEAR = 1980;

export const simpleFilterOptions = (input, option) =>
  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;

export const getSingleValidationStatus = (error, touched) => {
  if (!touched) return undefined;
  if (!error) return 'success';
  return 'error';
};

export const getSingleHelp = (error, touched) => {
  if (!touched && !error) return undefined;
  return error;
};

export const getValidateStatus = (values, errors, touched) => {
  return Object.keys(values).reduce((obj, key) => {
    const validateStatus = getSingleValidationStatus(errors[key], touched[key]);
    return { [key]: validateStatus, ...obj };
  }, {});
};

export const getHelp = (values, errors, touched) => {
  return Object.keys(values).reduce((obj, key) => {
    const help = getSingleHelp(errors[key], touched[key]);
    return { [key]: help, ...obj };
  }, {});
};

export const isDic = (a) => {
  return typeof a === 'object' && a != null && !Array.isArray(a);
};

// replace default values (a) with values if object (b) has them
export const zip = (a, b, stop = false) => {
  if (!b) return a;
  const c = { ...a };

  Object.keys(a).forEach((key) => {
    // Check if obj has key, otherwise use default option
    if (!stop && isDic(a[key])) {
      c[key] = zip(a[key], b[key], true);
    } else {
      c[key] = b[key] != null ? b[key] : a[key];
    }
  });

  return c;
};

export const getDatePickerValue = (value) => {
  if (typeof value === 'string') {
    return moment(value).clone();
  }
  return value;
};

export const over18 = (date) => moment().diff(date, 'years') < 18;
